import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';
import { SPACING, TYPOGRAPHY } from '../../../theme';
import { createIOSButtonStyles } from '../../../theme/iosButtonStyles';

/**
 * TemplateDashboardHeader Component
 *
 * Header section with title and create button.
 *
 * @param {Object} props
 * @param {Function} props.onCreateTemplate - Handler for creating a new template
 */
function TemplateDashboardHeader({ onCreateTemplate }) {
  return (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      mb={SPACING.xl}
      minHeight="80px"
      py={SPACING.md}
    >
      <Typography
        data-testid="templates-header"
        variant="h4"
        component="h1"
        sx={{
          ...TYPOGRAPHY.variants.h4,
          py: SPACING.md,
          lineHeight: 1.2,
        }}
      >
        Template Management
      </Typography>
      <Button
        variant="contained"
        startIcon={<AddIcon />}
        onClick={onCreateTemplate}
        sx={theme => {
          const iosStyles = createIOSButtonStyles(theme);
          return {
            // iOS-style primary button - flat, colors from theme
            ...iosStyles.primary,
            textTransform: 'none',
            fontFamily:
              "'Inter', -apple-system, BlinkMacSystemFont, 'SF Pro Display', sans-serif",
            py: SPACING.md,
            px: SPACING.lg,
            minHeight: '44px', // iOS standard touch target
            fontSize: '0.9375rem', // 15px - iOS standard
          };
        }}
      >
        Create Template
      </Button>
    </Box>
  );
}

export default TemplateDashboardHeader;
